import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const UnstyledLink = styled(Link)`
    color: unset;
    text-decoration: none;
`;
